module.exports = __webpack_public_path__ + "static/media/libro17.f38bfcda.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/libro17.png
// module id = 365
// module chunks = 0